// eslint-disable-next-line import/no-anonymous-default-export
export default {
  type: 'setDefaultMapCenter',
  options: {
    text: 'Set default map center',
  },
};
